import { render, staticRenderFns } from "./CreditProductSelector.vue?vue&type=template&id=ff589c58&scoped=true"
import script from "./CreditProductSelector.vue?vue&type=script&lang=js"
export * from "./CreditProductSelector.vue?vue&type=script&lang=js"
import style0 from "./CreditProductSelector.vue?vue&type=style&index=0&id=ff589c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff589c58",
  null
  
)

export default component.exports